import { GET_CUSTOMER_BY_ID_DATA_LOADING, GET_CUSTOMER_BY_ID_DATA_SUCCESS, GET_CUSTOMER_BY_ID__DATA_ERROR, RESET_GET_CUSTOMER_BY_ID_DATA_SUCCESS } from "../type/Constant";

let initialState = {
  getCustomerById: {
    loading: false,
    data: null,
    error: false,
    errors: null,
    success: false
  },
};

export default function getCustomerByIdReducer(state = initialState, action) {
  switch (action.type) {
   
    case GET_CUSTOMER_BY_ID_DATA_LOADING:
      return { ...state, getCustomerById: { ...state.getCustomerById, loading: true, error: false, errors: [], success: false } };

    case GET_CUSTOMER_BY_ID_DATA_SUCCESS:
      return { ...state, getCustomerById: { ...state.getCustomerById, loading: false, error: false, errors: [], success: true, data: action.response.data } };

    case GET_CUSTOMER_BY_ID__DATA_ERROR:
      return { ...state, getCustomerById: { ...state.getCustomerById, loading: false, error: true, errors: action.errors, success: false, data: null } };

    case RESET_GET_CUSTOMER_BY_ID_DATA_SUCCESS:
      return { ...state, getCustomerById: { ...state.getCustomerById, loading: false, error: false, errors: null, success: false } }

    default:
      return state;
  }
}
